import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient }  from '@/lib/api/queryClient';
import { AppRouter }    from '@/routes';
import { EnvironmentBanner } from '@/components/common/EnvironmentBanner';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <EnvironmentBanner />
      <AppRouter />
    </QueryClientProvider>
  );
}
